import React, { Fragment, useState } from "react"
import { RestHelper } from '../../helper/restHelper'
import PopupOverlay from "../popup-overlay"
import PopupOverlayResponseMessage from "../popup-overlay-response-message"

const NotaryDelete = (props) => {

    const api = RestHelper()

    var messageToSend = 'Are you sure you wish to delete ' + props.notary_name.firstName + ' ' + props.notary_name.lastName + '?'
    var passedMessage = messageToSend
    var passedObject = props.notary_name

    const [showPopup, setShowPopUp] = useState(false)
    const [showResponseMessage, setShowResponseMessage] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')
    
    const openPopup = () => {
        setShowPopUp(true)
    }
    
    const clearModal = () => {
        setShowPopUp(false)
    }

    const displayResponseMessage = (e) => {
        setResponseMessage(e)
        setShowResponseMessage(true)

    }
    const clearResponseMessage = () => {
        setShowResponseMessage(false)

    }

    const deleteNotary = () => {
        const options = {}
        const reqData = {'action' : 'delete', 'notary' : props.notary }
        api
            .postCreate('/manage-users-admin', options, reqData)
            .then(res => displayResponseMessage(res['Status']))
            .catch(err => console.log(err))
      }

return(
    <div>
        <button className="btn btn-sm btn-danger mt-3 mb-2 rounded" onClick={() => {openPopup()}}>
            Delete Notary
        </button>
    <Fragment>
        {showPopup && <PopupOverlay clearModal={clearModal} confirmAction={deleteNotary} passedMessage={passedMessage} passedObject={passedObject} />}
        {showResponseMessage && <PopupOverlayResponseMessage clearModal={clearResponseMessage} passedMessage={responseMessage} />}
    </Fragment>
    </div>
)
}
export default NotaryDelete;